<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="Functions Module" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Function List
                    .header-cta
                        router-link.btn-primary(to="/function/create") 
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user-plus"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
                            span(style="padding-left: 8px;") Add Function
            .box__body
                .form.px-4.py-4(
                    class="lg:py-0"
                )
                    .flex.flex-wrap.items-center.justify-between
                        .mr-0.mb-2.relative.field--search(
                            class="lg:mr-2 lg:mb-0"
                            )
                            input.field-style(id="field" type="text" v-model="keyword" placeholder="Search module here..." @keyup="searchKeyword")
                            .absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>

                        .flex.items-center.w-full(
                            class="lg:w-48"
                        )
                            span.block.mr-2 Show
                            .field.mr-2.relative.w-full
                                select.field-style.appearance-none.w-full.bg-white.border.border-gray-500.text-gray-700.py-2.px-2.pr-8.rounded.leading-tight#filter-record-size(@change="sizeChange($event)" v-model="items_per_page")
                                    option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

                            span entries


                .table-static.w-full.p-4
                    table.table-general
                        thead
                            tr
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_function_list === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")
                                    
                            template(v-else-if="function_list.data && function_list.data.length > 0")
                                tr(v-for="(mod_function,index) in function_list.data" :key="mod_function.id")
                                    td
                                        router-link.link-text(:to="'/function/'+mod_function.id+'/edit'") {{ mod_function.name }}
                                    td {{ mod_function.label }}
                                    td {{ mod_function.module && mod_function.module.name ? mod_function.module.name : '-' }}
                                    
                                    td {{ mod_function.description ? (mod_function.description.length > 16 ? mod_function.description.substring(0, 16)+'...' : mod_function.description) : '-' }}
                                    td.action
                                        .flex.items-center.justify-end
                                            router-link.btn-icon.btn-icon-40(:to="'/function/'+mod_function.id+'/edit'" v-tooltip="'Edit'")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                                                
                                            button.btn-icon.btn-icon-40( v-tooltip="'Delete'" @click="deleteData(mod_function.id, mod_function.name)")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            tr(v-else)
                                td.text-center(:colspan="tableThead.length") No Data Available
                    .mt-5
                    vue-ads-pagination(
                        :total-items="total_data"
                        :items-per-page="items_per_page"
                        :page="page"
                        :max-visible-pages="5"
                    )
                        template(slot="buttons" slot-scope="props")
                            vue-ads-page-button(
                                v-for="(button, key) in props.buttons"
                                :key="key"
                                v-bind="button"
                                :class="{'bg-yellow-dark': button.active}"
                                @page-change="page = button.page"
                                @range-change="start = button.start; end = button.end"
                            )

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'PageFunctionIndex',
    components: {
        HeaderGlobal,
        Spinner,
        // VueTableDynamic,
        VueAdsPagination,
        VueAdsPageButton,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Function',
                    url: '/Function',
                },
            ],
            tableThead: [
                {
                    name: 'Name',
                    // number: true,
                },{
                    name: 'Label',
                // },{
                //     name: 'Status',
                },{
                    name: 'Module',
                },{
                    name: 'Description',
                },{
                    name: 'Action',
                    action: true,
                },
            ],

            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_function_list',
            'function_list',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageFunctionIndex') {
                if (oldData !== 'PageFunctionIndex') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setFunctionList', {});
                }

                this.getData();
            }
        },
        function_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
    },
    methods: {
        getData() {

            this.$store.dispatch('getFunctionList', [this.items_per_page, (this.page + 1), this.keyword]);

            // if (this.function_list.total_page && this.function_list.total_page > 1) {
                // console.log(this.function_list.total_page)
                this.pagination();
            // }
        },
        deleteData(id, name) {
            // console.log(id)
            this.$swal.fire({
                icon: 'warning',
                // title: 'Are you sure you want to delete data?',
                title: 'Are you sure you want to delete?',
                // text: id,
                text: 'Function : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    // console.log(result.value);

                    this.showLoading(true);

                    this.$store.dispatch('getFunctionDelete', [id])
                    .then((resp) => {
                        if (resp === 'success') {
                            this.page = 0;

                            this.getData();

                            this.$swal.fire({
                                icon: 'success',
                                title: 'Data successfully deleted!',
                                timer: 3000,
                            });
                        } else {
                            if (resp.data.message) {
                                this.error(resp.data.message);
                            } else {
                                this.error();
                            }
                        }
                    });
                }
            });
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setUsersList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
    },
    mounted() {
        if (this.route_name === 'PageFunctionIndex') {
            this.getData();
            // this.pagination();
        }
    },
   
}
</script>

<style lang="sass">


</style>
